/**
 * hw-product-gallery.js
 * - Left strip thumbnails click → update main image with slide animation
 * - Variant color change → update main image to first matching color image
 */
(function () {

  // hwColorImages is populated by a <script> block in product-media-gallery.liquid
  // Each entry: { src, alt, color }

  /* ── Slide animation ─────────────────────────────────── */
  function animateTo(src, alt) {
    // Always query fresh — Shopify's updateMedia() can replace the DOM element
    var img = document.getElementById('hw-main-img');
    if (!img) return;

    img.classList.remove('hw-img-slide');
    void img.offsetWidth; // force reflow to restart animation
    img.classList.add('hw-img-slide'); // add before src change so image starts at opacity:0
    img.src = src;
    if (alt !== undefined) img.alt = alt;
  }

  /* ── Thumbnail click ─────────────────────────────────── */
  window.hwShowImage = function (src, alt, btnEl) {
    animateTo(src, alt);

    // Update active state — always query live DOM, never use cached refs
    document.querySelectorAll('.hw-shared-btn').forEach(function (b) {
      b.classList.remove('hw-thumb-active');
    });
    if (btnEl) btnEl.classList.add('hw-thumb-active');
  };

  /* ── Normalise color string for loose comparison ─────── */
  function norm(s) {
    return (s || '').toLowerCase().replace(/[\s\/\-_]/g, '');
  }

  /* ── Variant change → switch main image ─────────────── */
  function onVariantChange(event) {
    var variant = event && event.data && event.data.variant;
    if (!variant) return;

    // Determine which color option index to use
    var optEl = document.getElementById('hw-color-option-data');
    var colorIdx = optEl ? parseInt(optEl.dataset.colorOptionIndex, 10) : 1;
    var newColor = variant['option' + colorIdx];
    if (!newColor) return;

    var images = window.hwColorImages || [];
    for (var i = 0; i < images.length; i++) {
      if (norm(images[i].color) === norm(newColor)) {
        animateTo(images[i].src, images[i].alt);
        // Clear active thumbnail (we're now showing a color image)
        document.querySelectorAll('.hw-shared-btn').forEach(function (b) {
          b.classList.remove('hw-thumb-active');
        });
        return;
      }
    }
  }

  /* ── Preload image into browser cache ───────────────── */
  function preload(src) {
    if (!src) return;
    var img = new Image();
    img.src = src;
  }

  /* ── Init ────────────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', function () {
    mainImg = document.getElementById('hw-main-img');

    // Wire variant change pub/sub
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, onVariantChange);
    }

    // Preload on hover so image is cached before click
    document.querySelectorAll('.hw-shared-btn').forEach(function (btn) {
      btn.addEventListener('mouseenter', function () {
        preload(btn.dataset.src);
      }, { once: true });
    });

    // After page fully loads, preload all gallery images progressively in background
    window.addEventListener('load', function () {
      var btns = Array.from(document.querySelectorAll('.hw-shared-btn'));
      var i = 1; // skip first (already loaded as main image)
      function loadNext() {
        if (i >= btns.length) return;
        var img = new Image();
        img.onload = img.onerror = function () { i++; loadNext(); };
        img.src = btns[i].dataset.src;
      }
      setTimeout(loadNext, 800); // slight delay to not compete with page render
    });
  });

})();
